// @flow
import { NAVIGATION_TABS } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { CORE_GET_COMMON_I18N } from 'Utils/request/requestDictionary';

export const navigationTabsResolver = {
  name: NAVIGATION_TABS,
  resolve(appContext: AppContext) {
    const query = `query {
      config {
        common {
          scrollBackward
          scrollForward
        }
      }
    }`;
    return graphQLClient.runQuery(query, appContext, {
      requestName: CORE_GET_COMMON_I18N,
      strictErrors: false,
    });
  },
};
